import ITEM from 'utils/constants/items'
import roundCredits from 'utils/roundCredits'

export default function enhancer(input) {
    const { data = {} } = input
    return {
        ...input,
        data: {
            ...data,
            [ITEM.POST_RACE_ENGINE]: {
                ...data[ITEM.POST_RACE_ENGINE],
                options: data[ITEM.POST_RACE_ENGINE].options.map(option => ({
                    ...option,
                    healthIncrease: option.healthIncrease || (option.id === 'REPLACE' ? 100 : 0),
                    price: roundCredits(option.price || 0)
                }))
            },
            [ITEM.POST_RACE_GEARBOX]: {
                ...data[ITEM.POST_RACE_GEARBOX],
                options: data[ITEM.POST_RACE_GEARBOX].options.map(option => ({
                    ...option,
                    healthIncrease: option.healthIncrease || (option.id === 'REPLACE' ? 100 : 0),
                    price: roundCredits(option.price || 0)
                }))
            }
        }
    }
}



// WEBPACK FOOTER //
// src/utils/dataEnhancer/phases/postRace.js